<ng-template #modalTemplate>
	<div class="modal-body">
		<tacho-page-header></tacho-page-header>
		<div class="tacho-page">
			<div class="tacho-page-titles">
				<h1>{{message | translate}}</h1>
			</div>
			<tacho-data-loader loading="true" imageSrc="assets/images/page-body/checking_driver_card.svg"></tacho-data-loader>
		</div>
		<tacho-page-footer></tacho-page-footer>
	</div>
</ng-template>